module.exports = __webpack_public_path__ + "static/media/hw_ke_9.0dc98a35.flv";